import { memo, useEffect, useRef, useState } from 'react'

const PUBSUB_URL = 'https://pubsub-video.didderlive.com'
const pubSubPost = (channel: string, data: unknown) =>
  fetch(`${PUBSUB_URL}${channel}`, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ data }),
  }).catch(console.error)
import { useGetDiffTimer } from '../../../../hooks/date/use-get-diff-time'
import type { RocketGameLive } from '../../../../services/rockets-games-lives/types'

interface Props {
  currentRocketGameLive: RocketGameLive
  onFinish?: () => void
}

const LIVE_ROCKET_GAME = '/LIVE-ROCKET-GAME'

export const Timer = memo(({ currentRocketGameLive, onFinish }: Props) => {
  const timeToEnd = currentRocketGameLive?.dateFinalInExploded

  const intervalRef = useRef<NodeJS.Timeout | null>(null)
  const hasNotified = useRef<boolean>(false)

  const { handleCompareDates } = useGetDiffTimer(timeToEnd)

  const [timer, setTimer] = useState(() => {
    return handleCompareDates(new Date(), timeToEnd)
  })

  useEffect(() => {
    if (!hasNotified.current) {
      pubSubPost(`${LIVE_ROCKET_GAME}/br`, {
        imgRocketGame: currentRocketGameLive.rocketGame.imgRocketGame,
        rocketGameId: currentRocketGameLive.rocketGameId,
        rocketGameLiveId: currentRocketGameLive.id,
        typeRocketGameProgress: currentRocketGameLive.typeRocketGameProgress,
        message: 'O foguete estorou',
      })?.then(() => (hasNotified.current = true))
    }
  }, [])

  useEffect(() => {
    if (timeToEnd) {
      intervalRef.current = setInterval(() => {
        setTimer(() => handleCompareDates(new Date(), timeToEnd))
      }, 1000)
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
      }
    }
  }, [timeToEnd, handleCompareDates])

  useEffect(() => {
    if (timer?.minutes === 0 && timer?.seconds === 0) {
      onFinish?.()
    }
  }, [timer?.minutes, timer?.seconds, onFinish])

  if (timer?.minutes < 0 || timer?.seconds < 0) {
    return null
  }

  return (
    <span className="text-white text-sm">
      {String(timer?.minutes)?.padStart(2, '0')}:
      {String(timer?.seconds)?.padStart(2, '0')}
    </span>
  )
})

Timer.displayName = 'PkTimer'
